<div class="inbetriebnahme-container">

  <!-- HEADER -->
  <div class="page-header">
    <h1 class="page-title">
      <mat-icon class="title-icon">power_settings_new</mat-icon>
      Inbetriebnahme
    </h1>

    <div class="header-aktionen" *ngIf="canEdit">
      <button mat-stroked-button type="button" (click)="openVorlagen()"
        matTooltip="Spaltenstrukturen für manuell erstellte Listen verwalten">
        <mat-icon>view_column</mat-icon>
        Vorlagen
      </button>

      <button mat-stroked-button type="button" (click)="openNeueListe()"
        matTooltip="Leere Liste ohne Excel erstellen – Spalten selbst festlegen oder Vorlage verwenden">
        <mat-icon>playlist_add</mat-icon>
        Leere Liste erstellen
      </button>

      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="openImport()">
        <mat-icon>upload_file</mat-icon>
        Messstellenliste importieren
      </button>
    </div>
  </div>


  <!-- OHNE VERBINDUNG -->
  <mat-card class="offline-hinweis" *ngIf="istOffline && !isLoading">
    <mat-card-content>
      <mat-icon>cloud_off</mat-icon>
      <span>
        Keine Verbindung zum Server. Angezeigt werden nur Inbetriebnahmen,
        die offline verfügbar gemacht wurden.
      </span>
    </mat-card-content>
  </mat-card>


  <!-- LADEN -->
  <div class="loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>


  <!-- FEHLER -->
  <mat-card class="hint-card" *ngIf="loadError">
    <mat-card-content>{{ loadError }}</mat-card-content>
  </mat-card>


  <!-- NOCH KEINE INBETRIEBNAHME -->
  <mat-card
    class="hint-card"
    *ngIf="!isLoading && !loadError && listen.length === 0">
    <mat-card-content>
      <p>Noch keine Messstellenliste importiert.</p>

      <p class="hint-sub" *ngIf="canEdit">
        Über <strong>Messstellenliste importieren</strong> eine Excel-Datei (.xlsx) hochladen –
        die Zeilen werden dann als einzelne Messstellen gespeichert. Oder über
        <strong>Leere Liste erstellen</strong> die Spalten selbst festlegen und Messstellen von Hand erfassen.
      </p>
    </mat-card-content>
  </mat-card>


  <!-- INBETRIEBNAHMEN -->
  <div
    class="kachel-grid"
    *ngIf="!isLoading && !loadError && listen.length > 0">

    <div
      class="kachel"
      *ngFor="let inb of listen; trackBy: trackByInbetriebnahme"
      [class.kachel-fertig]="istFertig(inb)"
      [class.kachel-offen]="istOffen(inb)"
      [class.kachel-nicht-gestartet]="istNichtGestartet(inb)"
      (click)="openListe(inb)"
      matTooltip="Messstellen öffnen">

      <!-- TITEL + STATUS -->
      <div class="kachel-head">
      
        <span class="kachel-titel" *ngIf="inb.projektName || inb.customerName">{{ inb.projektNummer ? inb.projektNummer + ' · ' : '' }}{{ inb.projektName }}</span>

        <div class="kachel-head-actions">
          <span
            class="status-badge"
            [class.status-badge-fertig]="istFertig(inb)"
            [class.status-badge-offen]="istOffen(inb)"
            [class.status-badge-nicht-gestartet]="istNichtGestartet(inb)">
            {{ inbetriebnahmeStatusText(inb) }}
          </span>

          <button
            mat-icon-button
            class="delete-button"
            color="warn"
            type="button"
            *ngIf="canEdit"
            (click)="deleteListe(inb, $event)"
            matTooltip="Liste löschen">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>


      <!-- META -->
      <div class="kachel-meta">
        <span>
          <mat-icon inline>table_rows</mat-icon>
          {{ inb.messstellenCount }} Messstellen
        </span>

        <span>
          <mat-icon inline>category</mat-icon>
          {{ inb.messstellenMitKategorie }} kategorisiert
        </span>
      </div>


      <!-- PROJEKT / KUNDE -->
      <div class="kachel-context">
        <span>
          {{ inb.name }}
        </span>
        <span *ngIf="inb.customerName">{{ inb.customerName }}</span>
      </div>


      <!-- FORTSCHRITT -->
      <div class="kachel-progress" *ngIf="inb.messstellenCount > 0">
        <mat-progress-bar
          mode="determinate"
          [value]="inbetriebnahmeProzent(inb)">
        </mat-progress-bar>

        <span class="kachel-progress-text">
          {{ inb.messstellenMitPruefpunkten }} / {{ inb.messstellenCount }} gestartet
          · {{ inb.messstellenAbgeschlossen }} / {{ inb.messstellenCount }} geprüft
          · {{ inbetriebnahmeProzent(inb) }} %
        </span>

        <span
          class="kachel-progress-sub"
          *ngIf="inb.pruefpunkteGesamt > 0">
          {{ inb.pruefpunkteErledigt }} / {{ inb.pruefpunkteGesamt }} vorhandene Prüfpunkte abgearbeitet
        </span>
      </div>


      <!-- KEINE MESSSTELLEN -->
      <span class="kachel-keine" *ngIf="inb.messstellenCount === 0">
        noch keine Messstellen
      </span>


      <!--
        OFFLINE-KENNZEICHEN
        Heruntergeladen wird seit der Projektfunktion das ganze Projekt – auf
        der Projektseite. Hier steht nur noch, ob diese Liste dazugehört.
      -->
      <span class="status-badge status-badge--success kachel-offline" *ngIf="istOfflineVerfuegbar(inb.id)"
        matTooltip="Diese Liste ist über ihr Projekt auf diesem Gerät offline verfügbar">
        <mat-icon inline>offline_pin</mat-icon>
        Offline verfügbar
      </span>


      <!-- FOOTER -->
      <div class="kachel-fuss">
        {{ inb.importedAtUtc | date:'dd.MM.yyyy' }}
        <ng-container *ngIf="inb.importedByName">· {{ inb.importedByName }}</ng-container>
      </div>

    </div>

  </div>

</div>